import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { ResponseEnum } from "enums/response";
import { NoInfer } from "react-redux";
import {
  ContactUsState,
  ContactUSType,
  ContactUsTypeResponse,
} from "types/contact";

import { getContactUs } from "./contact.thunk";

export const extraReducers = (
  builder: ActionReducerMapBuilder<NoInfer<ContactUsState>>
) => {
  builder.addCase(
    getContactUs.fulfilled,
    (state: ContactUsState, action: PayloadAction<ContactUsTypeResponse>) => {
      if (action.payload.msg !== ResponseEnum.msgSuccess) return;

      const dataWhatsApp = action.payload.data.find((item: ContactUSType) =>
        item.Platform.includes("Whatsapp")
      );

      if (dataWhatsApp?.URL) state.URLWhatsApp = dataWhatsApp.URL;
    }
  );
};
